<div class="dropdown user_profile">
  <button class="btn btn-white d-flex align-items-center dropdown-toggle" type="button" data-bs-toggle="dropdown"
    aria-expanded="false" [disabled]="isRoleAdmin">
    <span class="d-none d-md-block mx-2">{{ selectedRole?.role_name || 'Select Role' }}</span>
  </button>
  <ul class="dropdown-menu w-100">
    <li *ngFor="let role of roles">
      <a class="dropdown-item" href="#" (click)="selectRole(role); $event.preventDefault()"
        [class.selected]="selectedRole?.role_id === role.role_id">
        {{ role.role_name }}
      </a>
    </li>
  </ul>
</div>